import {
  Button,
  Drawer,
  Flex,
  Grid,
  notification,
  Popconfirm,
  Steps,
  theme,
  Typography,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import GeneralInformation from "./GeneralInformation";
import {
  UsergroupAddOutlined,
  SmileOutlined,
  HomeOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import CommitteeInfo from "./CommitteeInfo";
import AgendaItem from "./AgendaItem";
import { useDispatch, useSelector } from "react-redux";
import {
  agendaCapture,
  agendaReplace,
  committeeCapture,
  generalInformationCapture,
  screenEnded,
  screenStart,
  hasChangeGeneralInformationCapture,
  hasChangeCommitteCapture
} from "../../redux/slices/meetingSlice";
import MasterDataAPI from "../../restAPI/MasterDataAPI";
import MeetingAPI from "../../restAPI/MeetingAPI";
import dayjs from "dayjs";
import moment from "moment";
import { useLocation } from "react-router-dom";
const { Text, Link } = Typography;
const { useBreakpoint } = Grid;

const NewMeetingDrawer = ({
  openDrawer,
  closeDrawer,
  drawerClose,
  selectedDate,
  setSelectedDate,
  isRecurring,
  setIsRecurring,
  selectedDays,
  setSelectedDays,
  value2,
  setValue2,
  current,
  setCurrent,
  isPrevClickedToGeneral,
  isPrevClickedToCommittee,
  setIsPrevClickedToGeneral,
  setIsPrevClickedToCommittee,
  actionState,
  originalDataObject,
  selectedMeetinId,
  meetingDate,
  originalDate,
  openNotificationWithIconf
}) => {
  const dispatch = useDispatch();
  const { generalInformation, committee, agenda, meetingCommonInfo ,hasChangeGeneralInformation,initialGeneralInformation,hasChangeCommitte} =
    useSelector((state) => state.meeting);
  const {
    token: {
      colorBgContainer,
      borderRadiusLG,
      colorPrimary,
      colorBorder,
      colorBgElevated,
    },
  } = theme.useToken();
  const { companyId, token, role } = useSelector((state) => state.auth);

  const generalInformationRef = useRef();
  const committeeInfoRef = useRef();
  const [selectedDateForMeeting, setSelectedDateForMeeting] = useState(null);
  const [committeeMembersList, setCommitteeMembersList] = useState([]);
  const [startAndEndTimeGap, setStartAndEndTimeGap] = useState(30);
  const [checkIsRecurring, setCheckIsRecurring] = useState(false);
  const [popConfShow, setPopConfShow] = useState(false);
  const [trackScopeType, setTrackScopeType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showUpdateButton, setShowUpdateButton] = useState(false);
  const [saveAddedPaperItemsInRedux, setSaveAddedPaperItemsInRedux] =
    useState(null);
  const [addedPapersList, setAddedPapersList] = useState(null);
  const [tempAddedPapersList, setTempAddedPapersList] = useState(null);
  const [
    openNotificationForEsignatureList,
    setOpenNotificationForEsignatureList,
  ] = useState(false);
  const [refreshAgendaItemsList, setRefreshAgendaItemsList] = useState(false);
  const [selectedRecurrence, setSelectedRecurrence] = useState("weekly");
  const [currentDayTileNumber, setCurrentDayTileNumber] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedDateFromCalendar = queryParams.get("date")
    ? dayjs(queryParams.get("date"))
    : dayjs();

  const screens = useBreakpoint();

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement,
    });
  };


  // check if the updated members list and current committe members are equal
  function areMemberArraysIdentical(updatedCommitteeMembersList, reduxCommitteeMembersList) {
      
    if (updatedCommitteeMembersList.length !== reduxCommitteeMembersList.length) return false;

      const normalizeMembers = (memberList) => {
        return memberList
          .map((member) => ({
            userDetailsId: member.userDetailsId,
            id: member.id,
            name: member.name,
            branch: member.branch || "",
            designation: member.designation || "",
            attendance: member.attendance || "optional",
            rsvp: member.rsvp || "default",
          }))
          .sort((memberA, memberB) => String(memberA.id).localeCompare(String(memberB.id)));
      };

      const sortedUpdatedMembers = normalizeMembers(updatedCommitteeMembersList);
      const sortedReduxMembers = normalizeMembers(reduxCommitteeMembersList);

      for (let index = 0; index < sortedUpdatedMembers.length; index++) {
        const updatedMember = sortedUpdatedMembers[index];
        const reduxMember = sortedReduxMembers[index];

        if (
          updatedMember.userDetailsId !== reduxMember.userDetailsId ||
          updatedMember.id !== reduxMember.id ||
          updatedMember.name !== reduxMember.name ||
          updatedMember.branch !== reduxMember.branch ||
          updatedMember.designation !== reduxMember.designation ||
          updatedMember.attendance !== reduxMember.attendance ||
          updatedMember.isDeletable !== reduxMember.isDeletable ||
          updatedMember.rsvp !== reduxMember.rsvp
        ) {
          return false;
        }
      }

      return true;
  }
  
  useEffect(()=>{
    const updatedMembers = committeeMembersList.map(
        ({ id, key, response, ...rest }) => rest
      );     
      if(committee){
        const areSame = areMemberArraysIdentical(
        updatedMembers || [],
        committee?.participant?.members || []
    );
    if(areSame){
      dispatch(hasChangeCommitteCapture(false));
    }else{
      dispatch(hasChangeCommitteCapture(true));
    }
      }      
  },[committeeMembersList])


  const newMeetingItems = [
    {
      title: "General Information",
      content: (
        <GeneralInformation
          isRecurring={isRecurring}
          setValue2={setValue2}
          value2={value2}
          setIsRecurring={setIsRecurring}
          selectedDays={selectedDays}
          setSelectedDays={setSelectedDays}
          ref={generalInformationRef}
          isPrevClickedToGeneral={isPrevClickedToGeneral}
          selectedDateForMeeting={selectedDateForMeeting}
          setSelectedDateForMeeting={setSelectedDateForMeeting}
          open2={openDrawer}
          startAndEndTimeGap={startAndEndTimeGap}
          setStartAndEndTimeGap={setStartAndEndTimeGap}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          actionState={actionState}
          selectedRecurrence={selectedRecurrence}
          setSelectedRecurrence={setSelectedRecurrence}
          currentDayTileNumber={currentDayTileNumber}
          setCurrentDayTileNumber={setCurrentDayTileNumber}
        />
      ),
      icon: <AppstoreOutlined />,
    },
    {
      title: "Members",
      content: (
        <CommitteeInfo
          ref={committeeInfoRef}
          committeeMembersList={committeeMembersList}
          setCommitteeMembersList={setCommitteeMembersList}
          isPrevClickedToCommittee={isPrevClickedToCommittee}
          actionState={actionState}
        />
      ),
      icon: <UsergroupAddOutlined />,
    },
    {
      title: "Papers",
      content: (
        <AgendaItem
          closeDrawer={closeDrawer}
          actionState={actionState}
          showUpdateButton={showUpdateButton}
          setShowUpdateButton={setShowUpdateButton}
          saveAddedPaperItemsInRedux={saveAddedPaperItemsInRedux}
          setSaveAddedPaperItemsInRedux={setSaveAddedPaperItemsInRedux}
          addedPapersList={addedPapersList}
          setAddedPapersList={setAddedPapersList}
          tempAddedPapersList={tempAddedPapersList}
          setTempAddedPapersList={setTempAddedPapersList}
          openNotificationForEsignatureList={openNotificationForEsignatureList}
          setOpenNotificationForEsignatureList={
            setOpenNotificationForEsignatureList
          }
          refreshAgendaItemsList={refreshAgendaItemsList}
          setRefreshAgendaItemsList={setRefreshAgendaItemsList}
          callbackfun={openNotificationWithIconf}
        />
      ),
      icon: <AppstoreOutlined />,
    },
  ];

  const reorderdForView = [
    newMeetingItems[2],
    newMeetingItems[0],
    newMeetingItems[1],
  ]

  const filteredMeetingItems = (() => {
    if(actionState === 'add' || actionState === 'edit'){
      return newMeetingItems.slice(0, 2) // General info and Members
    } else if(actionState === 'editPaper'){
      return [newMeetingItems[2]] // Only papers
    } else if(actionState === 'view'){
      return reorderdForView; // Custom order
    }
    return newMeetingItems
  })();

  const items = filteredMeetingItems.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const validAndSaveMeetingMemberList = async () => {
    let outPut = {};
    try {
      const values = await committeeInfoRef.current.validateAndRetrieveData();
      dispatch(screenStart());
      const { committeeType, committeeName } = values;

      if (!committeeType || !committeeName) {
        outPut = {
          status: false,
          outPutData: null,
        };
        throw new Error(
          "Validation failed: Committee type or name is missing."
        );
      }

      const updatedMembers = committeeMembersList.map(
        ({ id, key, response, ...rest }) => rest
      );

      const formattedValues = {
        participant: {
          committeeType: committeeType,
          committeeId: committeeName,
          members: updatedMembers,
        },
      };      
      
      dispatch(committeeCapture(formattedValues));
      setPopConfShow(false);
      outPut = {
        status: true,
        outPutData: formattedValues,
      };

      return outPut;
    } catch (error) {
      console.log("Validation failed :", error);
      outPut = {
        status: false,
        outPutData: error,
      };
      return outPut;
    }
  };

  const settingValues = async (screen) => {
    switch (screen) {
      case 0:
        let outPut = {};
        try {
          const values = await generalInformationRef.current.validateAndRetrieveData();
          // console.log('values :', values)
          dispatch(screenStart());

          const { meetingName, meetHeldAs, startDate, endDate, location, room, recurrence, repeatEvery, videoMethod, } = values;

          const formattedValues = {
            info: {
              name: meetingName ? meetingName.trim() : "Test meeting 1",
            },
            schedule: {
              startDate: values.startDate.toISOString(),
              endDate: values.endDate.toISOString(),
              // startDate: values.startDate.format('YYYY-MM-DDTHH:mm:ssZ'),
              // endDate: values.endDate.format('YYYY-MM-DDTHH:mm:ssZ')
            },
            held: {
              type: meetHeldAs,
              physical: {
                location:
                  meetHeldAs === "physical" || meetHeldAs === "hybrid"
                    ? location ? location : null
                    : "",
                room:
                  meetHeldAs === "physical" || meetHeldAs === "hybrid"
                    ? room ? room : null
                    : "",
              },
              online:
                meetHeldAs === "online" || meetHeldAs === "hybrid"
                  ? videoMethod
                  : "",
            },
            recurrence: {
              status: isRecurring,
              repeatEvery: isRecurring
                ? {
                    occurrence: values.repeatEvery,
                    type: recurrence ? recurrence : selectedRecurrence,
                    dayOfWeek: selectedDays,
                  }
                : {},
              repeatEnd: {
                type: isRecurring ? value2 : "on",
                onDate:
                  isRecurring && value2 === "on"
                    ? values.repeatEndOndDate.toISOString()
                    : null,
                afterOccurrence:
                  isRecurring && value2 === "after" 
                    ? values.endDateAfterOccurrence !== undefined && values.endDateAfterOccurrence !== null 
                      ? values.endDateAfterOccurrence 
                      : 10
                    : null,
              },
            },
          };

          const isIdentical = areMeetingsIdentical(initialGeneralInformation,formattedValues);          
          if(isIdentical){
            dispatch(hasChangeGeneralInformationCapture(false));
          }else{
            dispatch(hasChangeGeneralInformationCapture(true));                 
          }
          dispatch(generalInformationCapture(formattedValues));       
          

          if (actionState === "edit") {
            const originalDay = dayjs(originalDataObject.schedule.startDate).startOf("day");
            const updatedDay = dayjs(startDate).startOf("day");

            const {recurrence: { status }, schedule: { startDate: originalStartDate },} = originalDataObject;
            const updatedStartDate = dayjs(startDate).toISOString();

            if (isRecurring) {
              const { meetingDate, originalDate, participant, recurrence, ...filteredMeetingData } = originalDataObject;

              let scopeType = "this";
              let checkRecurring = true;
              let showPopConf = false;

              const isNameChanged = meetingName.trim().toLowerCase() !== (originalDataObject.info.name || "").trim().toLowerCase();

              const heldChanged =
                originalDataObject.held.type !== meetHeldAs ||
                (originalDataObject.held.physical?.location || "") !== ((meetHeldAs === "physical" || meetHeldAs === "hybrid") ? location : "") ||
                (originalDataObject.held.physical?.room || "") !== ((meetHeldAs === "physical" || meetHeldAs === "hybrid") ? room : "") ||
                JSON.stringify(originalDataObject.held.online || "") !== JSON.stringify((meetHeldAs === "online" || meetHeldAs === "hybrid") ? videoMethod : "");

              if (!originalDay.isSame(updatedDay)) {
                scopeType = "this";
              } else if (originalStartDate !== updatedStartDate) {
                showPopConf = true;
              } else if (!recurrence.status) {
                checkRecurring = false;
                scopeType = "following";
              } else if (JSON.stringify(filteredMeetingData) === JSON.stringify(formattedValues)) {
                // Nothing changed
                showPopConf = false;
              } else if (isNameChanged || heldChanged) {
                showPopConf = true;
              } else {
                // fallback
                showPopConf = false;
                scopeType = "this";
              }

              setTrackScopeType(scopeType);
              setCheckIsRecurring(checkRecurring);
              setPopConfShow(showPopConf);
            } else {
              let scopeType = "following";
              let checkRecurring = false;
              let showPopConf = false;

              if (!originalDay.isSame(updatedDay)) {
                scopeType = "this";
                checkRecurring = true;
              } else if (originalStartDate !== updatedStartDate) {
                scopeType = "following";
              }

              setTrackScopeType(scopeType);
              setCheckIsRecurring(checkRecurring);
              setPopConfShow(showPopConf);
            }


            // if (isRecurring) {
            //   const { meetingDate, originalDate, participant, recurrence, ...filteredMeetingData } = originalDataObject;
            //   if (!originalDay.isSame(updatedDay)) {
            //     // console.log("condingiton 1")
            //     // Condition 1: recurrence is true and the start day has changed
            //     setCheckIsRecurring(true);
            //     setPopConfShow(false);
            //     setTrackScopeType("this");
            //   } else if (originalStartDate !== updatedStartDate) {
            //     // Condition 2: recurrence is true, same start day, but different times
            //     // console.log("condingiton 2")
            //     setCheckIsRecurring(true);
            //     setPopConfShow(true);
            //   } else if (!recurrence.status) {
            //     // console.log("condingiton 3")
            //     // single day meeting turining into recurring meeting
            //     setCheckIsRecurring(false);
            //     setPopConfShow(false);
            //     setTrackScopeType("following");
            //   } else if (JSON.stringify(filteredMeetingData) === JSON.stringify(formattedValues)) {
            //     // console.log("condingiton 4")
            //     setCheckIsRecurring(true);
            //     setPopConfShow(false);
            //   } else if(meetingName.trim().toLowerCase() !== (originalDataObject.info.name || "").trim().toLowerCase()) {
            //     // if name change 
            //     console.log('name change')
            //     setCheckIsRecurring(true);
            //     setPopConfShow(true);
            //   } else if(
            //      originalDataObject.held.type !== meetHeldAs ||
            //      (originalDataObject.held.physical?.location || "") !== ((meetHeldAs === "physical" || meetHeldAs === "hybrid") ? location : "") ||
            //      (originalDataObject.held.physical?.room || "") !== ((meetHeldAs === "physical" || meetHeldAs === "hybrid") ? room : "") ||
            //      JSON.stringify(originalDataObject.held.online || "") !== JSON.stringify((meetHeldAs === "online" || meetHeldAs === "hybrid") ? videoMethod : "")
            //   ){
            //     // any of the Held changes
            //     console.log('any of the Held changes')
            //     setCheckIsRecurring(true);
            //     setPopConfShow(true);
            //   } else {
            //     // Nothing changes in general meeting. sometimes there can be changes in the committee, but it should not trigger 'this/following' 
            //     // console.log("condingiton 5")
            //     setCheckIsRecurring(true);
            //     setPopConfShow(false);
            //     setTrackScopeType("this");
            //   }
            // } else {
            //   // Condition 4: If recurrence is false
            //   if (!originalDay.isSame(updatedDay)) {
            //     // Condition 2-1: recurrence is false, start day has changed
            //     // console.log('Condition 2-1: recurrence is false, start day has changed')
            //     setTrackScopeType("this");
            //     setCheckIsRecurring(true);
            //     setPopConfShow(false);
            //   } else if (originalStartDate !== updatedStartDate) {
            //     // Condition 2-2: recurrence is false, same start day, but different times
            //     // console.log('Condition 2-2: recurrence is false, same start day, but different times')
            //     setCheckIsRecurring(false);
            //     setPopConfShow(false);
            //     setTrackScopeType("following");
            //   } else {
            //     setCheckIsRecurring(false);
            //     setPopConfShow(false);
            //     setTrackScopeType("following");
            //   }
            // }
          }
          outPut = {
            status: true,
            outPutData: formattedValues,
          };
          return outPut;
        } catch (error) {
          console.log("Validation failed :", error);
          outPut = {
            status: false,
            outPutData: error,
          };
          return outPut;
        }
        break;
      case 1:
        return await validAndSaveMeetingMemberList();
        break;
      // case 2:
      //     dispatch(agendaCapture({ "hobby": "chess" }));
      //     break;
    }
  };

  // check if the updated general information and general information in the redux are equal
  function areMeetingsIdentical(initialGeneralInformation, currentFormValues) {
    const isValueEqual = (firstValue, secondValue) => {
      if (firstValue === secondValue) return true;

      if (firstValue === null || secondValue === null) return firstValue === secondValue;

      if (typeof firstValue === "string" && typeof secondValue === "string") {
        const dateFromFirst = new Date(firstValue);
        const dateFromSecond = new Date(secondValue);
        if (!isNaN(dateFromFirst.getTime()) && !isNaN(dateFromSecond.getTime())) {
          return dateFromFirst.toISOString() === dateFromSecond.toISOString();
        }
      }

      if (firstValue instanceof Date && secondValue instanceof Date) {
        return firstValue.toISOString() === secondValue.toISOString();
      }

      if (Array.isArray(firstValue) && Array.isArray(secondValue)) {
        if (firstValue.length !== secondValue.length) return false;
        for (let index = 0; index < firstValue.length; index++) {
          if (!isValueEqual(firstValue[index], secondValue[index])) return false;
        }
        return true;
      }

      if (typeof firstValue === "object" && typeof secondValue === "object") {
        const keysFromFirst = Object.keys(firstValue);
        const keysFromSecond = Object.keys(secondValue);
        if (keysFromFirst.length !== keysFromSecond.length) return false;

        for (const key of keysFromFirst) {
          if (!keysFromSecond.includes(key)) return false;
          if (!isValueEqual(firstValue[key], secondValue[key])) return false;
        }

        return true;
      }

      return false;
    };

    return isValueEqual(initialGeneralInformation, currentFormValues);
  }


  const getUpdatedObject = (originalDataObject, updatedDataObject, scope) => {
    let updatedObject = {};

    if (originalDataObject.info?.name !== updatedDataObject.info?.name) {
      updatedObject.info = { ...updatedDataObject.info, scope };
    }

    if ( originalDataObject.schedule?.startDate !== updatedDataObject.schedule?.startDate || 
        originalDataObject.schedule?.endDate !== updatedDataObject.schedule?.endDate) {
        updatedObject.schedule = { ...updatedDataObject.schedule, scope };
    }

    if (originalDataObject.held?.type !== updatedDataObject.held?.type ||
        originalDataObject.held?.physical?.location !== updatedDataObject.held?.physical?.location ||
        originalDataObject.held?.physical?.room !== updatedDataObject.held?.physical?.room ||
        originalDataObject.held?.online !== updatedDataObject.held?.online) {
        updatedObject.held = { ...updatedDataObject.held, scope };
    }

    if (originalDataObject.recurrence?.status !== updatedDataObject.recurrence?.status ||
        JSON.stringify(originalDataObject.recurrence?.repeatEvery) !== JSON.stringify(updatedDataObject.recurrence?.repeatEvery) ||
        JSON.stringify(originalDataObject.recurrence?.repeatEnd) !== JSON.stringify(updatedDataObject.recurrence?.repeatEnd)) {
        updatedObject.recurrence = { ...updatedDataObject.recurrence, scope };
    }

    if (JSON.stringify(originalDataObject.participant?.members) !== JSON.stringify(updatedDataObject.participant?.members)) {
      updatedObject.participant = { ...updatedDataObject.participant, scope };
    }

    if (JSON.stringify(originalDataObject.agenda) !== JSON.stringify(updatedDataObject.agenda)) {
      updatedObject.agenda = [
        ...updatedDataObject.agenda.map((agenda) => ({ ...agenda, scope })),
      ];
    }

    return updatedObject;
  };

  const next = async () => {
    if (actionState === 'view') {
      setCurrent(current + 1);
      setIsPrevClickedToGeneral(false);
      setIsPrevClickedToCommittee(false);
      return;
    }

    const isValid = await settingValues(current);
    if (isValid.status) {
      setCurrent(current + 1);
      setIsPrevClickedToGeneral(false);
      setIsPrevClickedToCommittee(false);
    }
  };

  const prev = () => {
    setCurrent(current - 1);
    setIsPrevClickedToGeneral(current === 1);
    setIsPrevClickedToCommittee(current === 2);
  };

  const finalSubmit = async (scopeType) => {    
    const { committeeType, ...filteredGeneralInformation } = generalInformation || {};
    let isValid = null;
    let finalPayload = null;
    setStartAndEndTimeGap(30);

    if (actionState === "add") {
      isValid = await settingValues(current);

      finalPayload = {
        ...filteredGeneralInformation,
        ...isValid.outPutData,
        meetingStatus: "pending",
      };
      // console.log("finalPayload : create meeting :", finalPayload)

      if (isValid.status) {
        setIsLoading(true);
        committeeInfoRef.current.setLoading(true);
        try {
          const response = await MasterDataAPI.createMeeting(
            finalPayload,
            companyId,
            token
          );
          if (response.status === 200) {
            openNotificationWithIcon(
              "success",
              "Successful",
              `${response.data.message}`,
              "bottomLeft"
            );
            //closeDrawer();
            dispatch(screenEnded());
            setTrackScopeType("this");
            committeeInfoRef.current.setLoading(false);
          } else {
            openNotificationWithIcon("error", "Failed", `Meeting creation failed.`,"bottomLeft");
          }
        } catch (err) {
          console.log('meeting creation error :', err)
          console.error("Error:", err);
          dispatch(screenEnded());
          if(err?.response?.data){
            openNotificationWithIcon("error", "Failed", `${err?.response?.data?.message}`, "bottomLeft");
          } else{
            openNotificationWithIcon("error", "Failed", `Meeting creation failed.`, "bottomLeft");
          }
        } finally {
          closeDrawer();
          setIsLoading(false);
        }
      }
    } else if (actionState === "edit") {
      isValid = await settingValues(current);
      finalPayload = {
        ...filteredGeneralInformation,
        ...isValid.outPutData,
        meetingStatus: "pending",
      };

      const transformedOriginalObject = {
        ...originalDataObject,
        participant: {
          committeeId: originalDataObject.participant.committeeId,
          committeeType: originalDataObject.participant.committeeType,
          members: originalDataObject.participant.members.map((member) => ({
            userDetailsId: member.userDetailsId,
            attendance: member.attendance,
          })),
        },
      };

      const transformedFinalPayload = {
        ...finalPayload,
        participant: {
          committeeId: finalPayload.participant.committeeId,
          committeeType: finalPayload.participant.committeeType,
          members: finalPayload.participant.members.map((member) => ({
            userDetailsId: member.userDetailsId,
            attendance: member.attendance,
          })),
        },
      };

      let changes = getUpdatedObject(
        transformedOriginalObject,
        transformedFinalPayload,
        scopeType
      );
      console.log('changes :', changes)

      changes.meetingDate = dayjs(meetingDate).toISOString();
      changes.originalDate = dayjs(originalDate).toISOString();

      try {
        if (committeeInfoRef.current) {
          setIsLoading(true);
          committeeInfoRef.current.setLoading(true);
          const response = await MeetingAPI.updateMeeting(
            selectedMeetinId,
            companyId,
            token,
            changes
          );
          if (response.status === 200) {
            openNotificationWithIcon(
              "success",
              "Successful",
              `${response.data.message}`,
              "bottomLeft"
            );
            setTimeout(() => {
              closeDrawer();
              committeeInfoRef.current.setLoading(false);
            }, 700);
            setTrackScopeType("this");
          } else {
            openNotificationWithIcon(
              "error",
              "Failed",
              `Meeting edit failed.`,
              "bottomLeft"
            );
          }
        }
      } catch (error) {
        // dispatch(screenEnded());
          console.log('meeting creation error :', error)
        openNotificationWithIcon(
          "error",
          "Failed",
          `Meeting edit failed.`,
          "bottomLeft"
        );
        setTimeout(() => {
          closeDrawer();
          committeeInfoRef.current.setLoading(false);
        }, 700);
        console.log("Update meeting - error :", error);
      } finally {
        setIsLoading(false);
        setCheckIsRecurring(false);
      }
    } else if (actionState === "editPaper") {
      finalPayload = {
        originalDate: dayjs(meetingCommonInfo?.originalDate),
        agenda,
        meetingStatus: "pending",
      };
      setIsLoading(true);

      // console.log('finalPayload :', finalPayload)
      try {
        const response = await MeetingAPI.updateAgenda(
          selectedMeetinId,
          companyId,
          token,
          finalPayload
        );

        if (response.status === 200) {
          openNotificationWithIcon(
            "success",
            "Successful",
            `${response.data.message}`,
            "bottomLeft"
          );
          setTimeout(() => {
            closeDrawer();
          }, 700);
          setTrackScopeType("this");
        } else {
          openNotificationWithIcon(
            "error",
            "Failed",
            `Meeting paper update failed.`,
            "bottomLeft"
          );
        }
      } catch (error) {
        console.log("Update agenda error :", error);
        openNotificationWithIcon(
          "error",
          "Failed",
          `Meeting edit failed.`,
          "bottomLeft"
        );
      } finally {
        setIsLoading(false);
        setCheckIsRecurring(false);
      }
    }
  };

  const handleSaveOfPaperItems = () => {
    if (saveAddedPaperItemsInRedux) {
      dispatch(agendaReplace(saveAddedPaperItemsInRedux));
      setShowUpdateButton(false);
    }
  };

  const handleCancelPrioritiesChanges = () => {
    setShowUpdateButton(false);
    setAddedPapersList(tempAddedPapersList);
  };

  return (
    <div>
      <Drawer
        onClose={() => {
          generalInformationRef.current?.resetForm();
          setStartAndEndTimeGap(30);
          setAddedPapersList(null);
          setTempAddedPapersList(null);
          setRefreshAgendaItemsList(false);
          closeDrawer();
          setSelectedDays([]);
          setCurrentDayTileNumber(null);
          setSelectedDate(selectedDateFromCalendar);
        }}
        open={openDrawer}
        title={
          actionState === "add"
            ? "Add New Meeting"
            : actionState === "edit"
            ? "Update Meeting"
            : actionState === "editPaper"
            ? "Add/Edit Papers"
            : "View Meeting"
        }
        // size='large'
        width={screens.md ? "calc( 100% - 180px)" : null}
        footer={[
          <Flex justify="flex-end" align="center" gap="large">
            {current > 0 && <Button onClick={prev}>Previous</Button>}
            {current < filteredMeetingItems.length - 1 && (
              <Button type="primary" onClick={next}>
                Next
              </Button>
            )}
            {current === filteredMeetingItems.length - 1 && (
              <>
                {actionState === "add" ? (
                  <Button
                    type="primary"
                    onClick={finalSubmit}
                    loading={isLoading}
                  >
                    Done
                  </Button>
                ) : actionState === "view" ? (
                  <Button type="primary" onClick={closeDrawer}>
                    Close
                  </Button>
                ) : (
                  <>
                    {(checkIsRecurring && popConfShow) || (!checkIsRecurring && popConfShow) ? (
                      <Popconfirm
                        title="Select meeting update option"
                        okText="This and following"
                        onConfirm={() => finalSubmit("following")}
                        cancelText="This"
                        onCancel={() => finalSubmit("this")}
                        okButtonProps={{ type: "default" }}
                      >
                        <Button type="primary">Update</Button>
                      </Popconfirm>
                    ) : showUpdateButton ? (
                      <Flex
                        justify="space-between"
                        align="center"
                        gap={12}
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          width: "calc(100% - 20px)",
                          paddingLeft: 8,
                          paddingRight: 12,
                          paddingTop: 16,
                          paddingBottom: 16,
                          // marginBottom: 10,
                          borderTop: `1px solid ${colorBorder}`,
                          backgroundColor: colorBgElevated,
                          // marginTop: 10
                        }}
                      >
                        <div>
                          <Text>You have changes in priority order</Text>
                        </div>

                        <Flex justify="space-around" align="center" gap={12}>
                          <Button
                            type="primary"
                            onClick={() => handleSaveOfPaperItems()}
                          >
                            Save
                          </Button>
                          <Button
                            onClick={() => handleCancelPrioritiesChanges()}
                          >
                            Cancel
                          </Button>
                        </Flex>
                      </Flex>
                    ) : (
                      <Button
                        type="primary"
                        onClick={() =>                          
                          // finalSubmit(checkIsRecurring ? 'following' : trackScopeType !== null ? trackScopeType : 'this')
                          finalSubmit(
                            checkIsRecurring ? 
                              trackScopeType !== null ? 
                                trackScopeType
                                : "following"
                            : trackScopeType !== null ? 
                              trackScopeType
                              : "this"
                          )
                        }
                        loading={isLoading}
                        //disabled={!hasChangeCommitte && !hasChangeGeneralInformation}                        
                        // disabled={actionState === 'editPaper' && agenda?.categories?.length === 0}
                        disabled={(!hasChangeCommitte && !hasChangeGeneralInformation && actionState !== 'editPaper')}
                      >
                        Update
                      </Button>
                    )}
                  </>
                )}
              </>
            )}
          </Flex>,
        ]}
      >
        <Steps size="small" current={current} items={items} />
        <div style={{ marginTop: 24 }}>
          {filteredMeetingItems[current].content}
        </div>
      </Drawer>
      {contextHolder}
    </div>
  );
};

export default NewMeetingDrawer;
